import { useCallback, useEffect, useMemo, useReducer } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useBackURLFromQuery } from '../../hooks/useBackURLFromQuery';
import { useRandomGameRoute } from '../../hooks/useRandomGameRoute';
import {
  ROOT,
  BONUSES_LIST,
  BONUS_DETAIL,
  CAMPAIGN_DETAIL,
} from '../../constants/routeTemplates';
import CustomRouterContext from './RouterContext';
import { reducer, urlWasChanged } from './reducer';

const BONUS_DETAILS_ROUTES = [BONUS_DETAIL, CAMPAIGN_DETAIL];

// TODO: need refactoring to more stack-like structure
const CustomRouterContextProvider = ({ children }) => {
  const { pathname } = useLocation();
  const history = useHistory();

  const match = useRouteMatch(BONUS_DETAILS_ROUTES);
  const path = useMemo(() => (match && match?.path) || null, [match]);
  const backUrl = useBackURLFromQuery();
  const [state, dispatch] = useReducer(reducer, [backUrl || ROOT]);
  const randomGameRoute = useRandomGameRoute();

  const lastUrl = useMemo(() => {
    return state?.length > 2 ? state[state?.length - 2] : backUrl || ROOT;
  }, [state, backUrl]);

  useEffect(() => {
    if (BONUS_DETAILS_ROUTES.includes(path)) {
      dispatch(urlWasChanged(BONUSES_LIST));
    }
    if (pathname !== randomGameRoute) {
      dispatch(urlWasChanged(pathname));
    }
  }, [pathname, randomGameRoute, path]);

  const goPrevUrl = useCallback(() => {
    history.push(lastUrl);
  }, [lastUrl, history]);

  const contextValue = useMemo(
    () => ({
      goBack: goPrevUrl,
      lastUrl,
    }),
    [lastUrl, goPrevUrl]
  );

  return (
    <CustomRouterContext.Provider value={contextValue}>
      {children}
    </CustomRouterContext.Provider>
  );
};
export default CustomRouterContextProvider;
